// extracted by mini-css-extract-plugin
module.exports = {"seriesCard":"style-module__seriesCard___sEcND","active":"style-module__active___33CjR","compact":"style-module__compact___2s0sQ"};